import uuid from "uuid";

export default class InvoiceItem {
  id: string = uuid();
  unitName: string = "";
  unitType: string = "";
  unitPrice: number = 0;
  amount: number = 0;
  totalPrice: number = 0;
  memo: string = "";
  items: InvoiceItem[] = [];
}
